import styled from "styled-components";
import { Column, theme } from "uikit";

const Root = styled(Column)`
	background: ${theme.colors.button_secondary};
`;

export default Root;
